// extracted by mini-css-extract-plugin
export default {"root":"About_root__1MRbm"};